import { EstimateType } from "../../../pages/CreatorTools/MappingTool/utils/EstimateType";
import { FilterableSelect } from "../../../pages/components/GenericInputComponents";

interface EstimateTypeSelectorProps {
  value: EstimateType | undefined;
  onChange: (value: EstimateType | undefined) => void;
  label?: string;
  placeholder?: string;
  // When true, clearing the selector emits `undefined`. When false (default), clears are ignored.
  allowEmpty?: boolean;
}

function EstimateTypeSelector({ value, onChange, label = "Estimate Type", placeholder, allowEmpty = false }: EstimateTypeSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <FilterableSelect
        options={Object.values(EstimateType)}
        value={value}
        placeholder={placeholder}
        onSelect={(newValue) => {
          if (newValue) {
            onChange(newValue as EstimateType);
          } else if (allowEmpty) {
            onChange(undefined);
          } else {
            onChange(EstimateType.MITIGATION);
          }
        }}
      />
    </div>
  );
}

export default EstimateTypeSelector;
